import Hls from 'hls.js';
import { mobileDetect } from 'rp-gui-guide';
import { checkForAccess, subscriptionTypes } from 'rp-auth';

export default class {
    constructor($scope, $http, $q, $attrs, raceReplayService) {
        'ngInject';

        Object.assign(this, {
            $scope,
            $http,
            $q,
            $attrs,
            raceReplayService,
            videoHls: document.getElementById('replay-video'),
            hls: new Hls(),
        });

        this.setDefaultValues();
        this.initControls();
        /**
         *  [QW-795] Often rp-jquery-modal-lightbox not ready in moment of
         *  replays initialization. That's why barriers not always shown.
         *  So we need to postpone init.
         */
        setTimeout(() => this.init());
    }

    setDefaultValues() {
        const provider = this.$attrs.directiveRaceReplayProvider;
        const userSubscriptionLevel = this.$attrs.userSubscriptionLevel;
        localStorage.setItem('userRole', userSubscriptionLevel);

        Object.assign(this.$scope, {
            fullShown: false,
            closingShown: false,
            loading: false,
            error: '',
            containerHovered: false,
            provider,
            datetime: this.$attrs.directiveRaceReplayDatetime,
            raceId: this.$attrs.directiveRaceReplayRaceId,
            raceName: this.$attrs.directiveRaceReplayRaceName,
            raceTime: this.$attrs.directiveRaceReplayRaceTime,
            videoId: this.$attrs.directiveRaceReplay,
            courseName: this.$attrs.directiveRaceReplayCourseName,
            videoSrc: '',
            videoType: '',
            startSec: 0,
            endSec: null,
            onFullClick: () => this.onButtonClick(true, userSubscriptionLevel),
            onClosingClick: () => this.onButtonClick(false, userSubscriptionLevel),
            closeReplay: () => this.closeReplay(),
        });
    }

    init() {
        /**
         *  We unable to set currentTime when 'loadedmetadata' fires on iOS (closing stages).
         *  We can't use 'canplay' because it fires on rewind video too.
         */
        const loadedEvent = mobileDetect.os() === 'iOS' ? 'loadeddata' : 'loadedmetadata';
        this.videoHls.addEventListener(loadedEvent, () => {
            this.$scope.loading = false;
            this.$scope.$digest();
            this.play();
        });

        if (window.location.hash.includes('fullReplay')) {
            this.onButtonClick(true);
        }
    }

    initControls() {
        const isDesktop = !mobileDetect.isPhone() && !mobileDetect.tablet();
        this.$scope.isCustomControls = isDesktop;

        if (!isDesktop) {
            this.videoHls.controls = true;
        }
    }

    handleStopTime = () => {
        if (this.videoHls.currentTime > this.$scope.endSec) {
            this.videoHls.pause();
        }
    }

    play() {
        this.videoHls.currentTime = this.$scope.startSec;
        this.videoHls.play();
        if (this.$scope.endSec) {
            this.videoHls.addEventListener('timeupdate', this.handleStopTime);
        }
    }

    stop() {
        this.videoHls.pause();
        this.videoHls.removeEventListener('timeupdate', this.handleStopTime);
    }

    loadVideo = () => {
        this.videoHls.src = this.$scope.videoSrc;

        if (Hls.isSupported() && this.$scope.provider === 'ATR') {
            this.hls.loadSource(this.$scope.videoSrc);
            this.hls.attachMedia(this.videoHls);
        }
    }

    loadIPhoneVideo = () => {
        window.location = `${this.$scope.videoSrc}#t=${this.$scope.startSec},${this.$scope.endSec}`;
    }

    clearHash = () => {
        if (window.location.hash) {
            window.location.hash = '';
        }
    }

    setVideoInfo({ raceStart, raceEnd, closingStart, closingEnd, url }, isFullClick) {
        Object.assign(this.$scope, {
            videoSrc: url,
            videoType: this.$scope.provider === 'ATR' ? 'application/x-mpegURL' : 'video/mp4',
            startSec: isFullClick ? raceStart : closingStart,
            endSec: isFullClick ? raceEnd : closingEnd,
        });
    }

    onError = (errorMessage) => {
        this.raceReplayService.exitFullScreen(this.videoHls);
        Object.assign(this.$scope, { error: errorMessage, loading: false });

        if (!errorMessage) {
            this.closeReplay();
        }
    }

    openVideo = (isFullClick, loadVideo) => {
        this.raceReplayService.getVideo(isFullClick, this.$scope, this.onError)
            .then((data) => this.setVideoInfo(data, isFullClick))
            .then(this.clearHash)
            .then(loadVideo);
    }

    toggleEmbeddedVideoPlayer(isFullClick) {
        if (isFullClick && this.$scope.fullShown || !isFullClick && this.$scope.closingShown) {
            this.closeReplay();
        } else {
            this.stop();

            Object.assign(this.$scope, {
                fullShown: isFullClick,
                closingShown: !isFullClick,
                loading: true,
                error: '',
                videoSrc: '',
                startSec: 0,
                endSec: null,
            });

            this.openVideo(isFullClick, this.loadVideo);

            if (mobileDetect.isPhone() || mobileDetect.tablet()) {
                this.play();
                this.raceReplayService.enterFullScreen(this.videoHls);
            }
        }
    }

    onButtonClick(isFullClick, userSubscriptionLevel) {
        if (this.$scope.loading) {
            this.$scope.requestCanceler.resolve();
        }

        const isInsights = userSubscriptionLevel === subscriptionTypes.ESSENTIAL
        || userSubscriptionLevel === subscriptionTypes.INSIGHTS;
        const raceType = isFullClick ? 'full_replay' : 'closing_stages_replay';
        const text = isInsights ?
        // eslint-disable-next-line max-len
        'Access unlimited video race replays from all 86 racecourses in Britain and Ireland when you upgrade to a Racing Post+ Ultimate subscription.' :
        'To see race replays from all 86 UK & Ireland racecourses, subscribe to Ultimate';

        const hasAccess = checkForAccess('Subscriptions', true, false,
        { text, r: `${window.location}`, service: 'both' },
        true,
        userSubscriptionLevel,
        'results',
        raceType
    );

        if (hasAccess) {
            this.$scope.requestCanceler = this.$q.defer();

            if (mobileDetect.os() === 'iOS' && mobileDetect.isPhone()) {
                this.openVideo(isFullClick, this.loadIPhoneVideo);
            } else {
                this.toggleEmbeddedVideoPlayer(isFullClick);
            }
        }
    }

    closeReplay() {
        this.stop();
        Object.assign(this.$scope, { fullShown: false, closingShown: false, error: '' });
    }
}



// WEBPACK FOOTER //
// ./src/js/controllers/raceReplayCtrl.js